import React, { useState, useEffect } from "react";
import { Tab, Tabs, Card } from "react-bootstrap";
import moment from "moment";
import Loading from "../../../components/Loading";
import { post } from "../../../components/api";
import styles from "./Trips.module.css";
import tripArrow from "../../../assets/images/companies/trip_arrow.svg";
import { useNavigate } from "react-router-dom";

// Reusable TripCard Component
const TripCard = ({ data, key, cardClass, onClick }) => {
  const TripStatus = ({ status }) => {
    const statusClass =
      {
        "In Transit": "inTransit",
        Completed: "completed",
        Loading: "loading",
      }[status] || "default";
    return (
      <div className={`${styles.tripStatus} ${statusClass}`}>{status}</div>
    );
  };
  return (
    <div
      className="col-md-4 col-lg-4 col-xs-12 mb-3"
      key={key}
      onClick={onClick}
    >
      <Card className={cardClass}>
        <Card.Body>
          <div>
            <div className={styles.boxFirst}>
              <div className={styles.boxLayout}>
                <p className={styles.labelText}>Trip ID:</p>
                <p className={styles.valueText}>{data?.tripId}</p>
              </div>
              <div className={`${styles.boxLayout} mt-2 align-items-center`}>
                <p className={styles.labelText}>Trip Status:</p>
                <div className={styles.tripStatusParent}>
                  <TripStatus status={data?.status} />
                </div>
              </div>
            </div>
            <div className={`mt-2 ${styles.box}`}>
              <div className={styles.boxLayout1}>
                <img
                  src={tripArrow}
                  className="mt-2"
                  alt="Trip"
                  width={"9px"}
                  height={"74px"}
                />
                <div className="ml-2">
                  <div className="text-left">
                    <p className={styles.cityText}>
                      {`${data?.loads?.loadId?.fromCity?.city} , ${data?.loads?.loadId?.fromCity?.state}`}
                    </p>
                    <p className={styles.addText}>
                      {data?.loads?.loadId?.fromCity?.name}
                    </p>
                  </div>
                  <div className="text-left">
                    <p className={styles.cityText}>
                      {`${data?.loads?.loadId?.toCity?.city} , ${data?.loads?.loadId?.toCity?.state}`}
                    </p>
                    <p className={styles.addText}>
                      {data?.loads?.loadId?.toCity?.name}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className={`mt-2 ${styles.box}`}>
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column">
                  <div className="text-left mb-3">
                    <p className={styles.labelDetails}>Fleet Owner Name</p>
                    <p className={styles.valueDetails}>
                      {data?.loads?.loadId?.acceptedFleetOwnerId?.ownerName}
                    </p>
                  </div>
                  <div className="text-left mb-3">
                    <p className={styles.labelDetails}>Estimated Time</p>
                    <p className={styles.valueDetails}>18 hours</p>
                  </div>
                  <div className="text-left">
                    <p className={styles.labelDetails}>Trip Started Date</p>
                    <p className={`${styles.w68} ${styles.valueAddress}`}>
                      {moment(data?.loads?.tripStartTime).format(
                        "DD/MM/YYYY HH:mm"
                      )}
                    </p>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-start">
                  <div className="mb-3">
                    <p className={`${styles.labelDetails}`}>Truck Number</p>
                    <p className={`${styles.valueDetails}`}>
                      {data?.loads?.loadId?.vehicleId?.vehicleNo}
                    </p>
                  </div>
                  <div className="mb-3 text-left">
                    <p className={`${styles.labelDetails}`}>Total Distance</p>
                    <p
                      className={`${styles.valueDetails}`}
                    >{`${data?.loads?.distance} KM`}</p>
                  </div>
                  <div>
                    <p className={`${styles.labelDetails}`}>Delivery Date</p>
                    <p
                      className={`${styles.w68} ${styles.valueAddress} text-left font-17`}
                    >
                      <span>
                        {moment(data?.loads?.deliveryDate).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

const Trips = () => {
  const [key, setKey] = useState("Ongoing");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [tripData, setTripData] = useState([]);
  useEffect(() => {
    // const data = [
    //   {
    //     tripId: "#TRIP001",
    //     status: "Loading",
    //     origin: {
    //       city: "Ahmedabad",
    //       state: "Gujarat",
    //       address:
    //         "B Block, World Trade Tower, 412A, Ahmedabad, Gujarat 380051",
    //     },
    //     destination: {
    //       city: "Kuchipudi",
    //       state: "Kerala",
    //       address: "Unnamed Road, Near Backwaters, Alappuzha, Kerala - 688001",
    //     },
    //     fleetOwner: "ABC Logistics",
    //     truckNumber: "MH12AB1234",
    //     estimatedTime: "18 hours",
    //     totalDistance: "1200 km",
    //     tripStarted: "5 March 2025, 10:00 AM",
    //     deliveryDate: "5 March 2025, 10:00 AM",
    //   },
    //   {
    //     tripId: "#TRIP002",
    //     status: "In Transit",
    //     origin: {
    //       city: "Mumbai",
    //       state: "Maharashtra",
    //       address: "Nariman Point, Mumbai, Maharashtra 400021",
    //     },
    //     destination: {
    //       city: "Bangalore",
    //       state: "Karnataka",
    //       address: "Electronic City, Bangalore, Karnataka 560100",
    //     },
    //     fleetOwner: "XYZ Transport",
    //     truckNumber: "KA05CD5678",
    //     estimatedTime: "22 hours",
    //     totalDistance: "1400 km",
    //     tripStarted: "6 March 2025, 8:00 AM",
    //     deliveryDate: "7 March 2025, 6:00 AM",
    //   },
    //   {
    //     tripId: "#TRIP003",
    //     status: "Completed",
    //     origin: {
    //       city: "Delhi",
    //       state: "Delhi",
    //       address: "Connaught Place, New Delhi, Delhi 110001",
    //     },
    //     destination: {
    //       city: "Jaipur",
    //       state: "Rajasthan",
    //       address: "Pink City, Jaipur, Rajasthan 302001",
    //     },
    //     fleetOwner: "LMN Logistics",
    //     truckNumber: "RJ14EF9012",
    //     estimatedTime: "5 hours",
    //     totalDistance: "270 km",
    //     tripStarted: "4 March 2025, 6:00 AM",
    //     deliveryDate: "4 March 2025, 11:00 AM",
    //   },
    //   {
    //     tripId: "#TRIP004",
    //     status: "Completed",
    //     origin: {
    //       city: "Chennai",
    //       state: "Tamil Nadu",
    //       address: "Guindy Industrial Estate, Chennai, Tamil Nadu 600032",
    //     },
    //     destination: {
    //       city: "Hyderabad",
    //       state: "Telangana",
    //       address: "HITEC City, Hyderabad, Telangana 500081",
    //     },
    //     fleetOwner: "PQR Freight",
    //     truckNumber: "TS09GH3456",
    //     estimatedTime: "12 hours",
    //     totalDistance: "630 km",
    //     tripStarted: "6 March 2025, 7:30 AM",
    //     deliveryDate: "6 March 2025, 7:30 PM",
    //   },
    //   {
    //     tripId: "#TRIP005",
    //     status: "Completed",
    //     origin: {
    //       city: "Kolkata",
    //       state: "West Bengal",
    //       address: "Salt Lake City, Kolkata, West Bengal 700091",
    //     },
    //     destination: {
    //       city: "Patna",
    //       state: "Bihar",
    //       address: "Gandhi Maidan, Patna, Bihar 800001",
    //     },
    //     fleetOwner: "STU Logistics",
    //     truckNumber: "WB20IJ7890",
    //     estimatedTime: "10 hours",
    //     totalDistance: "580 km",
    //     tripStarted: "5 March 2025, 5:00 PM",
    //     deliveryDate: "6 March 2025, 3:00 AM",
    //   },
    // ];
  }, []);

  const getAllTrips = async (pageNumber, key) => {
    setIsLoading(true);
    try {
      const tripsData = await post("/company/ltms/companies-trips", {
        page: pageNumber,
        limit: 6,
        search: {
          city: "",
          status: key,
        },
      });
      if (tripsData.status == 200) {
        setTripData((prev) => [...prev, ...tripsData.data.trips]);
        setIsLoading(false);
      } else {
        setTripData([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error fetching vehicles", error);
    }
  };

  useEffect(() => {
    getAllTrips(page, key);
  }, [page, key]);

  const handleTabChange = async (key) => {
    setKey(key);
    setPage(1);
    setTripData([]);
    // setHasMore(true);
  };
  const navigate = useNavigate();

  const handleCardClick = (trip) => {
    navigate(`/company/trip/${trip._id}`, {
      state: { tripData: trip },
    });
  };

  return (
    <div className={`mt-4 ${styles.tripParent}`}>
      <Tabs
        activeKey={key}
        onSelect={handleTabChange}
        id="trip-tabs"
        className="custom-tabs"
      >
        <Tab eventKey="Ongoing" title="Ongoing Trips">
          <div className="row p-4">
            {isLoading ? (
              <Loading />
            ) : tripData.length > 0 ? (
              tripData.map((data, i) => (
                <TripCard
                  key={i}
                  data={data}
                  cardClass="trip-card"
                  onClick={() => handleCardClick(data)}
                />
              ))
            ) : (
              <p>No trips available</p>
            )}
          </div>
        </Tab>
        <Tab eventKey="Completed" title="Completed Trips">
          <div className="row p-4">
            {isLoading ? (
              <Loading />
            ) : tripData.length > 0 ? (
              tripData.map((data, i) => (
                <TripCard
                  key={i}
                  data={data}
                  cardClass="trip-card"
                  onClick={() => handleCardClick(data)}
                />
              ))
            ) : (
              <p>No trips available</p>
            )}
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default Trips;
